export default __webpack_public_path__ + "static/media/4.28f7c7c5.png";